import { Tabs, Tab, Box } from '@mui/material';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getCompetitionImage } from '@/helpers/leagues-helper';

const SelectorDeLigasPorPartido = ({ ligas = [], selectedLeague, setSelectedLeague }) => {
    const handleChange = (_, newValue) => {
        setSelectedLeague?.(newValue);
    };

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedLeague} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                <Tab label="Todas" value="-1" />
                {ligas?.map((leagueId) => (
                    <Tab
                        key={leagueId}
                        label={
                            <CustomImageComponent
                                src={getCompetitionImage(leagueId)}
                                width={20}
                                height={20}
                                alt="liga"
                            />
                        }
                        value={leagueId}
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default SelectorDeLigasPorPartido;
